export const RecentsImageSources = {
    emptyRecentsSrc: '/images/recents/empty_recents_illustration.svg',
    userAvatarSrc: '/images/recents/user_avatar.svg',
    incomingSrc: '/images/recents/incoming.svg',
    outgoingSrc: '/images/recents/outgoing.svg',
    emptyRecentsBgSrc: '/images/recents/empty_recents_bg.svg',
    localSrc: '/images/recents/local.svg'
}
